import React from 'react'
import SbEditable from 'storyblok-react'
import Figure from '../atoms/Figure'
import HeaderBlock from './HeaderBlock'

const ImageBlock = ({ block, className }) => {
  return (
    <SbEditable content={block}>
      <section
        className={`content-block-two-col ${className} ${
          block.space_top ? block.space_top : ''
        } ${block.space_bottom ? block.space_bottom : ''}`}
      >
        <HeaderBlock block={block} className="pt-0 pb-2" />
        <div className="content-block-two-col-body">
          <div className="row">
            <div className="content-col-1">
              <Figure
                image={block.image}
                image_link={block.image_link}
                align_image={block.align_image}
                image_size={block.image_size}
                caption={block.caption}
                parallax={false}
              />
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default ImageBlock
